<template>
  <v-slider
    :value="value"
    :tick-labels="ticksLabels"
    ticks="always"
    step="1"
    min="1"
    max="5"
    color="primary"
    tick-size="4"
    dense
    readonly
  />
</template>

<script>
export default {
  name: 'Slider',
  props: {
    value: {
      type: Number,
      required: true,
    },
    ticksLabels: {
      type: Array,
      required: true,
    },
  },
  methods: {
  },
}
</script>

<style scoped>
>>> .v-slider__tick-label {
  font-size: 0.8rem !important;
}
</style>
